import React from "react";
import { graphql, HeadProps, useStaticQuery } from "gatsby";

interface DefaultTitleProps {
    title?: string | null;
    metaDescription?: string | null;
    metaImagePath?: string | null;
    children?: React.JSX.Element;
    location?: HeadProps["location"];
}

export const query = graphql`
    query DefaultTitle {
        site {
            siteMetadata {
                title
                defaultMetaDescription
                siteUrl
            }
        }
    }
`;

const DefaultTitle = (props: DefaultTitleProps) => {
    const data = useStaticQuery(query);
    const {
        title,
        metaDescription = data.site.siteMetadata.defaultMetaDescription,
        // The default path is to the image in the `static/images/` folder in this project.
        // This will get transformed below into a FULL URL using the gatsby-config.ts `siteUrl` value.  Can't just use this
        // as relative path because the user's browser would be looking on whichever domain _they're_ on (example.com/images/lhit-logo.png, for instance)
        // rather than the full-and-complete _actual_ url.
        metaImagePath = "/images/genesee-brewery.jpg",
    } = props;

    let title_str = data.site.siteMetadata.title;
    if (!!title) title_str = `${title} | ${title_str}`;

    const metaTags = [];
    if (!!metaDescription)
        metaTags.push(
            <meta key="meta:description" name="description" content={metaDescription} />,
            <meta key="itemPropDescription" itemProp="description" content={metaDescription} />,
            <meta key="og:description" name="og:description" content={metaDescription} />,
            <meta key="twitter:description" name="twitter:description" content={metaDescription} />,
            <meta key="ogproperty:description" property="og:description" content={metaDescription} />
        );
    if (!!metaImagePath && !!data.site?.siteMetadata?.siteUrl) {
        const path = new URL(metaImagePath, data.site.siteMetadata.siteUrl);
        metaTags.push(
            <meta key="og:image" name="og:image" property="og:image" content={path.toString()} />,
            <meta key="twitter:image" name="twitter:image" property="twitter:image" content={path.toString()} />
        );
    }

    return (
        <>
            <title>{title_str}</title>
            {metaTags}
            {props.children}
        </>
    );
};

export default DefaultTitle;
